"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_dk4gdyryp() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/actions.js";
  var hash = "4f8699f900a6f7c438c6d5de6b2e4a69273e4770";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 5,
          column: 2
        }
      },
      "1": {
        start: {
          line: 3,
          column: 53
        },
        end: {
          line: 5,
          column: 1
        }
      },
      "2": {
        start: {
          line: 7,
          column: 47
        },
        end: {
          line: 11,
          column: 2
        }
      },
      "3": {
        start: {
          line: 7,
          column: 66
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "4": {
        start: {
          line: 13,
          column: 45
        },
        end: {
          line: 15,
          column: 2
        }
      },
      "5": {
        start: {
          line: 13,
          column: 52
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "6": {
        start: {
          line: 17,
          column: 13
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "7": {
        start: {
          line: 17,
          column: 23
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "8": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 52
        }
      },
      "9": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "10": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 36,
          column: 7
        }
      },
      "11": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 29,
          column: 7
        }
      },
      "12": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 80
        }
      },
      "13": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "14": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 21
        }
      },
      "15": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 55
        }
      },
      "16": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 102
        }
      },
      "17": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 46
          },
          end: {
            line: 3,
            column: 47
          }
        },
        loc: {
          start: {
            line: 3,
            column: 53
          },
          end: {
            line: 5,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 47
          },
          end: {
            line: 7,
            column: 48
          }
        },
        loc: {
          start: {
            line: 7,
            column: 66
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 45
          },
          end: {
            line: 13,
            column: 46
          }
        },
        loc: {
          start: {
            line: 13,
            column: 52
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 17,
            column: 14
          }
        },
        loc: {
          start: {
            line: 17,
            column: 23
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 17
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 17,
            column: 23
          },
          end: {
            line: 17,
            column: 24
          }
        },
        loc: {
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 17
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 25,
            column: 11
          }
        },
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 31,
            column: 5
          }
        },
        line: 25
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 32,
            column: 11
          },
          end: {
            line: 32,
            column: 12
          }
        },
        loc: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 32
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 29,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 29,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 32
          }
        }, {
          start: {
            line: 26,
            column: 36
          },
          end: {
            line: 26,
            column: 57
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4f8699f900a6f7c438c6d5de6b2e4a69273e4770"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dk4gdyryp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dk4gdyryp();
cov_dk4gdyryp().s[0]++;
var getResaleAvailabilityBeforeLoadAction = function getResaleAvailabilityBeforeLoadAction() {
  cov_dk4gdyryp().f[0]++;
  cov_dk4gdyryp().s[1]++;
  return {
    type: 'RESALE_AVAILABILITY_BEFORE_LOAD'
  };
};
cov_dk4gdyryp().s[2]++;
var getResaleAvailabilityLoadSuccessAction = function getResaleAvailabilityLoadSuccessAction(data, config) {
  cov_dk4gdyryp().f[1]++;
  cov_dk4gdyryp().s[3]++;
  return {
    type: 'RESALE_AVAILABILITY_LOAD_SUCCESS',
    data: data,
    config: config
  };
};
cov_dk4gdyryp().s[4]++;
var getResaleAvailabilityLoadErrorAction = function getResaleAvailabilityLoadErrorAction() {
  cov_dk4gdyryp().f[2]++;
  cov_dk4gdyryp().s[5]++;
  return {
    type: 'RESALE_AVAILABILITY_LOAD_ERROR'
  };
};
cov_dk4gdyryp().s[6]++;
var load = function load(config) {
  cov_dk4gdyryp().f[3]++;
  cov_dk4gdyryp().s[7]++;
  return function (dispatch) {
    cov_dk4gdyryp().f[4]++;
    cov_dk4gdyryp().s[8]++;
    // first dispatch the beforeLoad action
    dispatch(getResaleAvailabilityBeforeLoadAction());
    var urlPath = (cov_dk4gdyryp().s[9]++, "".concat(config.restHost, "/v1/catalog/resale-configuration"));

    // then fetch the catalog
    cov_dk4gdyryp().s[10]++;
    return (0, _gAxios.default)(urlPath, {
      headers: config.headers
    }).then(function (response) {
      cov_dk4gdyryp().f[5]++;
      cov_dk4gdyryp().s[11]++;
      if ((cov_dk4gdyryp().b[1][0]++, response.status >= 200) && (cov_dk4gdyryp().b[1][1]++, response.status < 300)) {
        cov_dk4gdyryp().b[0][0]++;
        cov_dk4gdyryp().s[12]++;
        dispatch(getResaleAvailabilityLoadSuccessAction(response.data, config));
        cov_dk4gdyryp().s[13]++;
        return response.data;
      } else {
        cov_dk4gdyryp().b[0][1]++;
      }
      cov_dk4gdyryp().s[14]++;
      throw response;
    }).catch(function (response) {
      cov_dk4gdyryp().f[6]++;
      cov_dk4gdyryp().s[15]++;
      dispatch(getResaleAvailabilityLoadErrorAction());
      cov_dk4gdyryp().s[16]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_dk4gdyryp().s[17]++;
      return response;
    });
  };
};
var _default = exports.default = {
  load: load
};